import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { Header, flexRender } from '@tanstack/react-table';
import React from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';

interface Props {
    header: Header<any, unknown>;
    sort: boolean;
    hideFilter?: boolean;
    className?: string;
    customDivClassName?: string;
    tableId: string;
    dispatch: ThunkDispatch<any, any, Action>;
}

export function THeaderItem(props: Props) {
    const sortState = props.header.column.getIsSorted() ? (props.header.column.getIsSorted() === 'desc' ? 'desc' : 'asc') : '';

    if (props.header.id === 'selection' || props.header.id === 'expand') {
        return (
            <th
                key={props.header.id}
                colSpan={props.header.colSpan ?? 1}>
                {flexRender(props.header.column.columnDef.header, props.header.getContext())}
            </th>
        );
    }

    // Narrow icon-only column (platform SHARED_COLUMN_ID) — skip default min-w-40.
    if (props.header.id === 'shared') {
        return (
            <th
                scope='col'
                key={props.header.id}
                colSpan={props.header.colSpan}
                className={`${props.className ?? ''} w-10 max-w-12 px-2 text-center hover:cursor-default`}>
                <div className='text-foreground-default flex w-full items-center justify-center text-base font-medium'>
                    {flexRender(props.header.column.columnDef.header, props.header.getContext())}
                </div>
            </th>
        );
    }

    return (
        <th
            scope='col'
            key={props.header.id}
            colSpan={props.header.colSpan}
            className={`${props.className ?? ''} min-w-40 px-4 hover:cursor-default`}
            onClick={() => undefined}>
            <div
                className={
                    props.customDivClassName
                        ? props.customDivClassName
                        : `text-foreground-default border-border-default flex w-full items-center justify-between gap-3 text-base font-medium`
                }>
                <span className='whitespace-nowrap'>{flexRender(props.header.column.columnDef.header, props.header.getContext())}</span>
                {props.sort && (
                    <span
                        className={`${props.sort ? 'hover:cursor-pointer' : ''} flex flex-col justify-start`}
                        onClick={() => props.header.column.toggleSorting()}>
                        <LuChevronUp className={`text-foreground-default translate-y-[3px] transform ${sortState === 'asc' ? 'opacity-100' : 'opacity-50'}`} />
                        <LuChevronDown
                            className={`text-foreground-default translate-y-[-3px] transform ${sortState === 'desc' ? 'opacity-100' : 'opacity-50'}`}
                        />
                    </span>
                )}
            </div>
        </th>
    );
}
